import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Row, Col, message } from 'antd';
import axios from 'axios';
import Configuration from '../../Configuration.js';
import TopGuardMenu from '../../components/TopGuardMenu';
import VisitService from '../../components/access/VisitService';
import VisitEmployee from '../../components/access/VisitEmployee';
import VisitVisitor from '../../components/access/VisitVisitor';
import VisitCarrier from '../../components/access/VisitCarrier';
import VisitKindModal from '../../components/modals/VisitKindModal';
import VisitServiceDetails from '../../components/access/VisitServiceDetails';
import VisitCarrierDetails from '../../components/access/VisitCarrierDetails';
import VisitEmployeeDetails from '../../components/access/VisitEmployeeDetails';
import VisitVisitorDetails from '../../components/access/VisitVisitorDetails';
import './Access.css';

class Access extends Component {
  constructor() {
    super();

    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = { redirect: false, excessWeightVisible: false, changePasswordVisible: false, visitKindModal: false, visits: [], filteredVisits: [], currentVisit: {}, cameras: [], total: 0, loading: false, page: 1 };
    this.validateToken = this.validateToken.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.getVisits = this.getVisits.bind(this);
    this.selectVisit = this.selectVisit.bind(this);
    this.viewPhoto = this.viewPhoto.bind(this);
    this.updateVisitProps = this.updateVisitProps.bind(this);
    this.handleVisitDetails = this.handleVisitDetails.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getVisits(1);
    const timeline = document.querySelector('.visits-list');
    timeline.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});

    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "guardia")) 
      this.setState({redirect: true});
  }

  handleScroll() {
    // Get scroll position
    const timeline = document.querySelector('.visits-list');
    const restHeight = (timeline.scrollHeight - timeline.offsetHeight);

    // Load next page
    if(restHeight <= timeline.scrollTop) {
      const pageLimit = Math.ceil(this.state.total / 10);
      const page = this.state.page;

      // Prevent excess the pages limit
      if(page < pageLimit) {
        if(!this.state.loading) {
          this.getVisits(page + 1);
          // Update state of page
          this.setState({page: page + 1, loading: true});
        }

        // Add timeout for every page request
        setTimeout(() => {
          this.setState({loading: false});
        }, 1000);
      } else {
        message.warning('Ya no tienes más visitas anteriores');
      }
    }
  }

  getVisits(page) {
    axios.get(`${Configuration.apiServer}/api/v1/today-visits?page=${page}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(!('visits' in resp.data))
        return message.warning('Petición inválida')

      const currentVisits = this.state.visits.concat(resp.data.visits);
      this.setState({visits: currentVisits, filteredVisits: currentVisits, total: resp.data.total});

      if(resp.data.visits.length > 0) {
        this.setState({currentVisit: resp.data.visits[0]});
      }
    });
  }

  handleSearch(event) {
    const filter = this.state.visits.filter(visit => {
      switch(visit.visit_kind.kind.name) {
        case 'Servicio':
          return visit.visit_kind.service.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
        case 'Transportista':
          return visit.visit_kind.visit_ticket.driver.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1 || visit.visit_kind.visit_ticket.carrier.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
        case 'Empleado':
          return visit.profile.names.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
        case 'Visita a planta':
          if(visit.visitors.length > 0)
            return visit.visitors[0].name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
          return false;
        default:
          return visit.visit_kind.service.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      }
    });

    this.setState({filteredVisits: filter});
  }

  updateVisitProps(id, prop, value) {
    let currentIndex = 0;
    let visits = this.state.visits;

    visits.forEach((visit, index) => {
      if(visit.id === id) {
        currentIndex = index;
      }
    });

    visits[currentIndex][prop] = value;
    this.setState({visits: visits, filteredVisits: visits});
  }

  viewPhoto(camera) {
    let mainPhotoImg = document.querySelector('.main-photo-img');
    mainPhotoImg.setAttribute('src', Configuration.apiServer+camera.name.url);
    let mainPhotoLink = document.querySelector('.main-link-photo-in');
    mainPhotoLink.setAttribute('href', Configuration.apiServer+camera.name.url);
  }

  handleOpenModal(kind) {
    let modal = {};
    modal[kind] = true;
    this.setState(modal);
  }

  handleCloseModal(kind){
    let modal = {};
    modal[kind] = false;
    this.setState(modal);
  }

  selectVisit(visit) {
    this.setState({currentVisit: visit});
  }

  handleVisitDetails(visit) {
    if('id' in visit) {
      if(visit.visit_kind.kind.name === 'Servicio') {
        return (
          <VisitServiceDetails visit={visit} />
        );
      } else if(visit.visit_kind.kind.name === 'Transportista') {
        return (
          <VisitCarrierDetails visit={visit} />
        );
      } else if(visit.visit_kind.kind.name === 'Empleado') {
        return (
          <VisitEmployeeDetails visit={visit} />
        );
      } else if(visit.visit_kind.kind.name === 'Visita a planta') {
        return (
          <VisitVisitorDetails visit={visit} />
        );
      }
    }
  }

  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // List visits
    const visitItems = this.state.filteredVisits.map(visit => {
      switch(visit.visit_kind.kind.name) {
        case 'Servicio':
          return (
            <VisitService key={`visit:service:${visit.id}`} visit={visit} update={this.updateVisitProps} handleClick={this.selectVisit} />
          );
        case 'Empleado':
          return (
            <VisitEmployee key={`visit:employee:${visit.id}`} visit={visit} update={this.updateVisitProps} handleClick={this.selectVisit} />
          );
        case 'Visita a planta':
          return (
            <VisitVisitor key={`visit:visitor:${visit.id}`} visit={visit} update={this.updateVisitProps} handleClick={this.selectVisit} />
          );
        case 'Transportista':
          return (
            <VisitCarrier key={`visit:carrier:${visit.id}`} visit={visit} update={this.updateVisitProps} handleClick={this.selectVisit} />
          );
        default:
          return (
            <VisitService key={`visit:service:${visit.id}`} visit={visit} update={this.updateVisitProps} handleClick={this.selectVisit} />
          );
      }
    });
    
    return (
      <div>
        <Row type="flex" justify="start">
          <Col span={18} >
            <div className="heading-left-side">
              <TopGuardMenu handleOpen={ this.handleOpenModal } />
              {/* Searcher */}
              <div className="main-searcher">
                <div className="form-group">
                  <input type="text" className="form-control mt-3 w-75 mx-auto" placeholder="Buscar visita..." onChange={this.handleSearch} />
                </div>
              </div>
              {/* Add Button */}
              <button className="btn btn-primary btn-add" onClick={ () => {this.handleOpenModal('visitKindVisible')} }>
                <i className="material-icons">add</i>
              </button>
            </div>

            {/* Listing */}
            <div className="visits-list">
              <div className="visits-list-heading">
                <div className="visits-list-heading-content d-flex justify-content-between" style={{ width: '100%', marginLeft: '0px' }}>
                  <span style={{ width: '20%' }}></span>
                  <h6 className="m-0 text-muted" style={{ width: '30%' }}>Visita</h6>
                  <h6 className="m-0 text-muted" style={{ width: '30%' }}>Fecha / Hora</h6>
                  <h6 className="m-0 text-muted" style={{ width: '20%' }}>Status</h6>
                </div>
              </div>
              <span className="mt-5 d-block"></span>
              <div className="timeline">
                {visitItems}
              </div> 
            </div>
          </Col>
          

          <Col span={6} >
            {/* Heading right side */}
            <div className="heading-right-side">
              <div className="d-flex flex-column align-items-center">
                Placas
                <button className="btn btn-warning btn-sm">Verificar</button>
              </div>
            </div>

            {/* Visit photos */}
            <div className="visit-photos-wrapper">
              <div className="visit-photos">
                <div className="big-photo p-relative">
                  <div className="p-absolute btn-outline btn-take-all-the-photos">Tomar todas las fotos</div>
                  <a title="" className="main-link-photo-in" data-toggle="lightbox" data-gallery="example-gallery">
                    <img src="imgs/imagen-no-disponible.jpg" alt="" className="img-fluid main-photo-img" />
                  </a>
                  <div className="p-absolute thumbnails-photos w-100">
                    <div className="d-flex justify-content-center algin-items-center">
                    </div>
                  </div>
                </div>
                <div className="take-a-specific-photo d-flex justify-content-between align-items-center p-2">
                  <h6 className="text-muted m-0 d-block">Identificación</h6>
                  <button className="btn btn-primary btn-sm">Tomar foto</button>
                </div>
              </div>
            </div>
            
            {/* Visit Details */}
            {this.handleVisitDetails(this.state.currentVisit)}
          </Col>
        </Row>

        <VisitKindModal visible={this.state.visitKindVisible} title={'Nueva visita'} service={true} employee={true} carrier={true} visitor={true}  handleClose={ () => {this.handleCloseModal('visitKindVisible')} } handleList={this.getVisits} quick={true} hideDate={true} />
      </div>
    )
  }
}

export default Access;



// WEBPACK FOOTER //
// ./src/pages/guard/Access.js